<template>
  <section v-if="posts.length" class="article-list">
    <!-- Post -->
    <PostCard
      v-for="(post, postIndex) in posts"
      :key="`post-card-${postIndex}`"
      :title="post.title"
      :slug="post.slug"
      :date="post.date"
      :thumbnail="post.thumbnail"
      :categories="post.categories"
      :min-read="post.minRead"
    />
    <!-- ./Post -->
  </section>
</template>
<script>
import PostCard from '~/components/blog/post/PostCard.vue';

export default {
  name: 'PostList',
  components: {
    PostCard,
  },
  props: {
    posts: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.article-list {
  @apply md:container px-5 lg:px-0 md:px-0 mb-[30px] grid grid-cols-6 gap-x-[30px];

  .article-card {
    @apply lg:col-span-2 col-span-full;

    &:nth-child(1),
    &:nth-child(2) {
      @apply lg:col-span-3 col-span-full;

      > .article-card__featured-image {
        @apply h-[384px];
      }
    }
  }
}
</style>
